import CaretStringIterator from "./CaretStringIterator";
class RTLCaretStringIterator extends CaretStringIterator {
  constructor(caretString) {
    super(caretString);
  }
  insertionAffectsCaret = () => this.currentIndex <= this.caretString.caretPosition;
}
export default RTLCaretStringIterator;
//# sourceMappingURL=RTLCaretStringIterator.js.map